<script>
    import { t } from 'totalinvoice-frontend-core'

    export let title
    export let status

    let statusColor
    let statusText

    $: {
        if (status === 'online') {
            statusColor = 'is-success'
            statusText = $t('online')
        } else if (status === 'offline') {
            statusColor = 'is-danger'
            statusText = $t('offline')
        } else {
            statusColor = 'is-warning'
            statusText = $t('unknown')
        }
    }
</script>

{#if statusColor && title && statusText}
    <div class="tags has-addons">
        <span class="tag is-large is-light">{title}</span>
        <span class="tag is-large {statusColor}">{statusText}</span>
    </div>
{/if}
